import { ActivatedRoute } from '@angular/router';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
import { NacinPlacanja } from './nacin-placanja';

@Component({
  selector: 'yt-nacin-placanja',
  templateUrl: './nacin-placanja.component.html'
})
export class NacinPlacanjaComponent extends BaseModalContainer<NacinPlacanja> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<NacinPlacanja>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) { 
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
